import {Controller} from '@hotwired/stimulus';

/**
 * Affiche à la demande un secret que la page ne contient pas : « Afficher » le demande en POST à l'URL en value
 * (réponse JSON `{"value": …}`, `null` pour un secret illisible), l'écrit à la place de la mention, puis disparaît.
 * Pendant l'envoi, le bouton est en chargement (`is-loading`, `aria-disabled`) : le spinner remplace son icône et un
 * second clic est ignoré. Un échec affiche le libellé `error` et laisse réessayer.
 * Posé par le composant Twig `SecretReveal`.
 *
 *   <span {{ stimulus_controller('secret-reveal', {url: path('…'), labels: {unreadable: '…', error: '…'}}) }}>
 *     <span {{ stimulus_target('secret-reveal', 'output') }} aria-live="polite">Valeur enregistrée</span>
 *     <button type="button" class="btn" {{ stimulus_target('secret-reveal', 'button') }}
 *             {{ stimulus_action('secret-reveal', 'reveal') }}><svg>…</svg>Afficher</button>
 *   </span>
 */
export default class extends Controller {
  static targets = ['output', 'button'];
  static values = {url: String, labels: Object};

  async reveal() {
    if (this.buttonTarget.getAttribute('aria-disabled') === 'true') {
      return;
    }

    this.buttonTarget.classList.add('is-loading');
    this.buttonTarget.setAttribute('aria-disabled', 'true');

    try {
      const response = await fetch(this.urlValue, {method: 'POST', headers: {Accept: 'application/json'}});

      if (response.ok) {
        const {value} = await response.json();

        this.outputTarget.textContent = value ?? this.labelsValue.unreadable;
        this.buttonTarget.remove();

        return;
      }
    } catch (error) {
      console.error('Error:', error);
    }

    this.outputTarget.textContent = this.labelsValue.error;
    this.buttonTarget.classList.remove('is-loading');
    this.buttonTarget.removeAttribute('aria-disabled');
  }
}
